import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import hive from "@/hive";
import store from "@/store";

// Get a Firestore instance
export const db = firebase.firestore();

export const rtDb = firebase.database();

// collection references
const collections = {
  users: db.collection("users"),
  leads: db.collection("leads"),
  comments: db.collection("comments"),
  leadComments: db.collection("comments"),
  // .where("location", ">=", "leads/")
  // .where("location", "<", "leads/")
  // .orderBy("location"),
  inboundEmails: db.collection("inboundEmails"),
  _counters: db.collection("_counters")
};
const users = {
  async getFullName(id) {
    if (!id) return null;
    let doc = await users.getUser(id);
    if (!doc) return null;
    if (doc.name) {
      let name = doc.name;
      if (doc.surname) {
        name += " " + doc.surname;
      }
      // console.log(name);
      return name;
    } else {
      return doc.displayName;
    }
  },
  async getUser(id) {
    let doc = await collections.users.doc(id).get();
    return doc.data();
  },
  currentUserUid() {
    return currentUser().uid;
  },
  currentUser() {
    return currentUser();
  }
};
const docs = {
  labels: {
    leads: db.collection("labels").doc("leads")
  }
};
const docById = {
  lead(id) {
    return collections.leads.doc(id);
  }
};
async function _update(doc, keyOrObj, value, toast) {
  try {
    let go;
    if (typeof keyOrObj === "string") {
      go = {};
      go[keyOrObj] = value;
    } else {
      go = keyOrObj;
    }
    // go.lastEditedBy = currentUser().uid;
    // console.log(currentUser());
    // console.log(doc);
    // console.log(go);
    await doc.set(go, { merge: true });
  } catch (e) {
    if (toast) {
      hive.toastError(e.message);
    } else {
      throw e;
    }
  }
}
const DocHelper = class {
  constructor(collectionName, docId, noToast, noLog) {
    this._id = docId;
    this._collection = collectionName;
    this._doc = db.collection(collectionName).doc(docId);
    this.noToast = noToast;
    this.noLog = noLog;
    console.log(this);
  }

  get id() {
    return this._id;
  }
  get doc() {
    return this._doc;
  }
  get patch() {
    return this._collection + "/" + this._id;
  }

  async update(keyOrObj, value) {
    let go;
    if (typeof keyOrObj === "string") {
      go = {};
      go[keyOrObj] = value;
    } else {
      go = keyOrObj;
    }
    if (!this.noLog) {
      go.lastEditedBy = currentUser().uid;
    }
    for (let key in go) {
      if (go[key] === undefined) go[key] = null;
    }
    // console.log(go);
    try {
      await this._doc.set(go, { merge: true });
    } catch (e) {
      if (!this.noToast) {
        hive.toastError(e.message);
      } else {
        throw e;
      }
    }
  }
  async delete() {
    try {
      await this.update("deletedBy", currentUser().uid);
      await this._doc.delete();
    } catch (e) {
      if (!this.noToast) {
        hive.toastError("Delete Lead Error: " + e.message);
      } else {
        throw e;
      }
    }
  }
};
DocHelper.newDoc = async (collection, data) => {
  data.createdBy = currentUser().uid;
  data.dateCreated = firebase.firestore.FieldValue.serverTimestamp();
  const ref = await db.collection(collection).add(data);
  return new DocHelper(collection, ref.id);
};
const docHelpers = {
  lead(id) {
    return new DocHelper("leads", id);
  }
};

// const serverTimestamp = () => {
//   return firebase.firestore.Timestamp.fromDate(new Date());
// };

const updaters = {
  async lead(id, key, value) {
    console.log(arguments);
    await _update(collections.leads.doc(id), key, value);
  },
  labels: {
    async leads(key, value) {
      // console.log(arguments);
      return await _update(docs.labels.leads, key, value);
    }
  }
};

const meta = {
  async projects(onMarket, construction) {
    const p = await rtDb.ref("_meta/projects").once("value");
    const val = p.val();
    const result = [];
    Object.keys(val).forEach(k => {
      const v = val[k];
      if (onMarket && !v.onMarket) return;
      if (construction && !v.construction) return;
      result.push({ label: v.name, value: k });
    });
    return result;
  },
  async sources() {
    const s = await rtDb.ref("_meta/leads/sources").once("value");
    return s.val();
  },
  leads: {
    async commentActions() {
      const s = await rtDb.ref("_meta/leads/commentActions").once("value");
      return s.val();
    }
  }
};
const metaRefs = {
  leads: {
    commentActions: rtDb.ref("_meta/leads/commentActions")
  }
};
/////////////////////////// direct db operations /////////////////////////////////
const leads = {
  async followUp(id, date) {
    await updaters.lead(id, "followUp", date);
  },
  async del(id) {
    await updaters.lead(id, "deletedBy", currentUser().uid);
    try {
      await docById.lead(id).delete();
      console.log("deleted" + id);
    } catch (e) {
      hive.toastError("Delete Lead Error: " + e.message);
    }
  }
};

const currentUser = () => {
  return store.getters["user/getUser"];
};

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore;
export {
  meta,
  Timestamp,
  GeoPoint,
  collections,
  docs,
  docById,
  // _update,
  updaters,
  users,
  metaRefs,
  leads,
  DocHelper,
  docHelpers
  // serverTimestamp
};
